export enum StudentQueryKeys {
  TARGET_SKILL_FINISHED = 'TARGET_SKILL_FINISHED',
  TARGET_SKILL_NOT_STARTED = 'TARGET_SKILL_NOT_STARTED',
  SUPPORT_SKILL_ALL_COMPLETED = 'SUPPORT_SKILL_ALL_COMPLETED',
  SUPPORT_SKILL_SOME_IN_PROGRESS = 'SUPPORT_SKILL_SOME_IN_PROGRESS',
  SUPPORT_SKILL_PENDING = 'SUPPORT_SKILL_PENDING',
}

export const cardReferencesTarget = [
  {
    key: 'targetSkillFinished',
    label: 'Completed',
    icon: 'nc_icon-nc_selected',
    studentQueryKey: StudentQueryKeys.TARGET_SKILL_FINISHED,
  },
  {
    key: 'targetSkillNotStarted',
    label: 'Not Started',
    icon: 'nc_icon-nc_warning',
    studentQueryKey: StudentQueryKeys.TARGET_SKILL_NOT_STARTED,
  },
];
export const cardReferencesSupport = [
  {
    key: 'supportSkillAllCompleted',
    label: 'All Completed',
    icon: 'nc_icon-nc_selected',
    studentQueryKey: StudentQueryKeys.SUPPORT_SKILL_ALL_COMPLETED,
  },
  {
    key: 'supportSkillSomeInProgress',
    label: 'Some in Progress',
    icon: 'nc_icon-nc_warning',
    studentQueryKey: StudentQueryKeys.SUPPORT_SKILL_SOME_IN_PROGRESS,
  },
  {
    key: 'supportSkillPending',
    label: 'Not Started',
    icon: 'nc_icon-nc_warning',
    studentQueryKey: StudentQueryKeys.SUPPORT_SKILL_PENDING,
  },
];
